import {Color} from '~/constants/style';

export const iconContainerStyle = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
};

export const amountStyle = {
  color: Color.PrimaryMain,
  fontWeight: 700,
  mt: 2,
};
export const titleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  color: Color.Purple600,
  whiteSpace: 'nowrap',
};
export const descriptionStyle = {
  fontSize: '16px',
  fontWeight: 600,
  color: Color.Purple600,
  mt: 0.5,
};
